module.exports = __webpack_public_path__ + "img/ebillet.ca937365.svg";